/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useMount, useUpdateEffect } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import RobotDirectRegisterCard from '../../components/robot/RobotDirectRegisterCard';
import AccordionCard from '../../components/AccordionCard';
import {
  onDirectRemoveItem,
  updateRemoveItem,
  initRemoveItem,
} from '../../modules/robot';
import { Alert } from '../../common/util';
import Toast from '../../components/Toast';
// import { checkSerialAPI } from '../api/robot';

const RobotDeleteContainer = () => {
  const state = useSelector((rootState) => rootState.robot);
  const dispatch = useDispatch();
  const { removeItem, removed, error } = state;
  const [open, setOpen] = useState(true);
  const [doneDisabled, setDoneDisabled] = useState(false);
  const [snack, setSnack] = useState({ open: false });

  const onOpen = () => {
    dispatch(initRemoveItem());
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onItemChange = (item) => {
    const { v, n } = item;
    const changeItems = n.split('-');
    const prop = changeItems[0];
    const event = changeItems[1];
    let newValue;
    if (prop === 'serials') {
      if (event === 'add') {
        if (removeItem.serials.find((serial) => serial === v)) {
          return Alert('이미 추가한 시리얼입니다.');
        }
        newValue = removeItem.serials.concat(v);
      }
      if (event === 'delete') {
        const index = removeItem.serials.indexOf(v);
        const serials = [...removeItem.serials];

        serials.splice(index, 1);
        newValue = [...serials];
      }
    } else {
      newValue = v;
    }
    const newRemoveItem = { ...removeItem, [prop]: newValue };
    return dispatch(updateRemoveItem(newRemoveItem));
  };
  useUpdateEffect(() => {
    let changed = false;
    let e = '';
    if (removeItem.error) {
      changed = true;
      e += Object.values(removeItem.error).join('');
    }
    setDoneDisabled(!changed || (changed && e.length !== 0));
  }, [removeItem]);

  const onSave = () => {
    const { userId, serials } = state.removeItem;
    dispatch(onDirectRemoveItem({ userId, serials }));
  };

  const handleSnackClose = () => {
    setSnack({ open: false });
  };

  useUpdateEffect(() => {
    if (removed && removed.length === removeItem.serials.length) {
      setSnack({
        open: true,
        onClose: () => {
          handleSnackClose();
          dispatch(initRemoveItem());
        },
        message: `${removed.length}개의 로봇이 삭제되었습니다.`,
        severity: 'success',
        duration: 1500,
      });
    }
  }, [removed]);

  useUpdateEffect(() => {
    if (error && 'remove' in error && error.remove) {
      setSnack({
        open: true,
        onClose: handleSnackClose,
        message: '로봇 삭제 도중 오류가 발생하였습니다.',
        severity: 'error',
      });
    }
  }, [error]);

  useMount(() => dispatch(initRemoveItem()));

  return (
    <>
      <AccordionCard
        {...{
          title: '로봇 삭제',
          done: { label: '완료', onClick: onSave, disabled: doneDisabled },
          fold: { label: '접기', onClick: onClose },
          unfold: { label: '삭제', onClick: onOpen },
        }}
        open={open}
      >
        <Grid container>
          <Grid item xs={12}>
            <RobotDirectRegisterCard
              {...removeItem}
              key="card"
              onCancel={() => dispatch(initRemoveItem())}
              onComplete={() => onSave()}
              onChange={(v, n) => onItemChange({ v, n })}
              name="remove"
            />
          </Grid>
        </Grid>
      </AccordionCard>
      <Toast {...{ ...snack }} />
    </>
  );
};

export default RobotDeleteContainer;
